module.exports = __webpack_public_path__ + "7902c266c38e090c3299a6dd2af108a3.png";